var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BasePortalHost } from 'app/ui/core/portal';
import { UIPortalHostDirective } from 'app/ui/core/portal-directives';
var UIDialogComponent = /** @class */ (function (_super) {
    __extends(UIDialogComponent, _super);
    function UIDialogComponent() {
        var _this = _super.call(this) || this;
        _this.noPadding = false;
        return _this;
    }
    UIDialogComponent.prototype.ngOnInit = function () {
        this.noPadding = this.dialogConfig.noPadding || false;
    };
    UIDialogComponent.prototype.attachComponentPortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throw new Error('Attempting to attach dialog content after content is already attached');
        }
        return this._portalHost.attachComponentPortal(portal);
    };
    UIDialogComponent.prototype.attachTemplatePortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throw new Error('Attempting to attach dialog content after content is already attached');
        }
        this._portalHost.attachTemplatePortal(portal);
    };
    return UIDialogComponent;
}(BasePortalHost));
export { UIDialogComponent };
